if (document.querySelector('.visualsSwiper')) {
    const swiper = new Swiper('.visualsSwiper', {
        speed: 700,
        spaceBetween: 16,
        slidesPerView: 1,
        navigation: {
            nextEl: '.visualsSwiper__arrow--right',
            prevEl: '.visualsSwiper__arrow--left',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 56,
            },
            1440: {
                slidesPerView: 4,
                spaceBetween: 96,
            },
        },
    });
}
